// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import { useState } from "react";
import { Collapse, useTheme } from "@mui/material";
import useTranslation from "next-translate/useTranslation";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import Image from "next/image";

import { IconButton, Grid, Link, Box, Card } from "@/components/core";
import { useShortcutMenuStore } from "@/store/shortcut-menu";

export default function TemporaryDrawer() {
  const theme = useTheme();
  const { t } = useTranslation("common");

  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(false);
  const [contactAnchor, setContactAnchor] = useState(null);

  const shortcuts = useShortcutMenuStore((state: any) => state.shortcuts);
  const isMounted = useShortcutMenuStore((state: any) => state.isMounted);

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  const list = (
    <Box
      sx={{
        background: theme.palette.secondary.main,
        color: theme.palette.background.default,
      }}
      onKeyDown={toggleDrawer}
    >
      <List>
        <ListItemButton>
          <IconButton color="inherit">
            <Image src="/svg/savings.svg" alt="savingIcon" width={20} height={20} />
          </IconButton>
          <ListItemText primary={t("navbar.confirmStatus")} />
        </ListItemButton>

        <ListItemButton>
          <IconButton color="inherit">
            <Image src="/svg/lastProcess.svg" alt="lastProcessIcon" width={20} height={20} />
          </IconButton>
          <ListItemText primary={t("navbar.transactions")} />
        </ListItemButton>

        <ListItemButton>
          <IconButton color="inherit">
            <CurrencyExchangeIcon style={{ fontSize: 20 }} />
          </IconButton>
          <ListItemText primary={t("navbar.currencyInformation")} />
        </ListItemButton>
      </List>
      <ListItemButton
        href="/money-transfer"
        style={{
          border: "1px solid white",
          borderRadius: "10px",
          margin: 10,
        }}
      >
        {t("sendMoney")}
      </ListItemButton>

      <ListItemButton
        href="/accounts"
        style={{ border: "1px solid white", borderRadius: "10px", margin: 10 }}
      >
        {t("accounts")}{" "}
      </ListItemButton>
      {isMounted && (
        <>
          <ListItemButton
            href=""
            onClick={() => setMenuAnchor(!menuAnchor)}
            style={{ border: "1px solid white", borderRadius: "10px", marginInline: 10 }}
          >
            {t("menu")}
            {menuAnchor ? (
              <KeyboardArrowUpIcon sx={{ verticalAlign: "middle" }} />
            ) : (
              <KeyboardArrowDownIcon sx={{ verticalAlign: "middle" }} />
            )}
          </ListItemButton>

          <Collapse in={menuAnchor} timeout={500}>
            <Card sx={{ p: 2, m: 1 }}>
              {shortcuts
                .filter((s: any) => s.group === "menu")
                .map((shortcut: any) => (
                  <Grid.Item key={shortcut.id}>
                    <Link href={shortcut.href ?? "#"} key={shortcut.value}>
                      <Grid spacing={2}>
                        <Grid.Item xs={1}> {shortcut.icon}</Grid.Item>
                        <Grid.Item xs={11}> {shortcut.name}</Grid.Item>
                      </Grid>
                    </Link>
                  </Grid.Item>
                ))}
            </Card>
          </Collapse>
        </>
      )}
      <ListItemButton
        href="#"
        onClick={() => setContactAnchor(!contactAnchor)}
        style={{
          border: "1px solid white",
          borderRadius: "10px",
          marginTop: 10,
          marginBottom: 20,
          marginInline: 10,
        }}
      >
        {t("contact")}
        {contactAnchor ? (
          <KeyboardArrowUpIcon sx={{ verticalAlign: "middle" }} />
        ) : (
          <KeyboardArrowDownIcon sx={{ verticalAlign: "middle" }} />
        )}
      </ListItemButton>
      <Collapse in={contactAnchor} timeout={500}>
        <Card sx={{ p: 2, m: 1 }}>
          {shortcuts
            .filter((s: any) => s.group === "contact")
            .map((shortcut: any) => (
              <Grid.Item key={shortcut.id}>
                <Link href={shortcut.href ?? "#"} key={shortcut.value}>
                  <Grid spacing={2}>
                    <Grid.Item xs={1}> {shortcut.icon}</Grid.Item>
                    <Grid.Item xs={11}> {shortcut.name}</Grid.Item>
                  </Grid>
                </Link>
              </Grid.Item>
            ))}
        </Card>
      </Collapse>
    </Box>
  );

  return (
    <>
      <IconButton color="inherit" onClick={toggleDrawer}>
        {isDrawerOpen ? (
          <CloseIcon style={{ fontSize: 40 }} />
        ) : (
          <MenuIcon style={{ fontSize: 40 }} />
        )}
      </IconButton>

      <Drawer
        anchor="top"
        open={isDrawerOpen}
        onClose={toggleDrawer}
        PaperProps={{
          style: {
            marginTop: 80,
            background: theme.palette.secondary.main,
          },
        }}
        BackdropProps={{ invisible: true }}
      >
        {list}
      </Drawer>
    </>
  );
}
